export const ACTION_DUPLICATE = 'duplicate';
export const ACTION_ADD_ANOTHER = 'addAnother';
export const ACTION_ADD_PROMO_CODE = 'addPromocode';
export const ACTION_EXPORT_LINKS = 'exportLinks';
